import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sectionTitle: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.section-title',
		defaultMessage: 'Release 14% more often with Jira and Bitbucket',
		description: 'Title of the section talking about the benefits',
	},
	sectionDescriptionSpork: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.section-description-spork',
		defaultMessage:
			"Teams that integrate Jira with Bitbucket release versions 14% more often \nthan those who don't.",
		description: 'Description of the section talking about the benefits',
	},
	topSectionValueTitle: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.top-section-value-title',
		defaultMessage: "Get visibility into your team's work, from issue to code",
		description: 'Title of the header value',
	},
	topSectionValueDescriptionMessageSpork: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.top-section-value-description-message-spork',
		defaultMessage:
			'Create an automated DevOps workflow and minimize context switching between Jira and <bold>Bitbucket, GitHub, GitLab</bold>, and other source code management tools.',
		description: 'Description of the header value',
	},
	value1Title: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-1-title',
		defaultMessage: 'Collaborate on code with the right context',
		description: 'Title of the first value',
	},
	value1Description: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-1-description',
		defaultMessage:
			'Manage your entire development workflow, from code to deployment. Get the context your team needs to ship  better software with a first-in-class Jira integration.',
		description: 'Description of the first value',
	},
	value2TitleSpork: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-2-title-spork',
		defaultMessage: 'Simply copy & paste issue keys to start work in Jira',
		description: 'Title of the second value',
	},
	value2Description: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-2-description',
		defaultMessage:
			'Use issue keys to link development tools to issues. Include an issue key in any branches, commit messages, or pull requests you create sending data back in to your Jira projects.',
		description: 'Description of the second value',
	},
	value3Title: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-3-title',
		defaultMessage: 'Connect your entire workflow with automation',
		description: 'Title of the third value',
	},
	value3Description: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.value-3-description',
		defaultMessage:
			"Make multiple updates with one action. Streamline your team's workflow by better tracking of productivity, code writing, reviews and testing.",
		description: 'Description of the third value',
	},
});
